import { ProcessingProgress } from '@/components/ProcessingProgress'
import { Card, CardContent } from '@/components/ui/card'
import { usePing } from '@/hooks/usePing'
import { useRef, type ReactNode } from 'react'
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs'

interface AppLayoutProps {
  children: ReactNode
}

export const AppLayout = ({ children }: AppLayoutProps) => {
  const { isLoading } = usePing()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const { breadcrumbs } = useBreadcrumbs()

  return (
    <div className="mt-14 flex h-screen flex-1 flex-col overflow-hidden pb-10">
      <div
        ref={scrollContainerRef}
        data-scroll-container
        className="@container/main flex flex-1 flex-col overflow-y-auto"
      >
        <div className="mx-auto flex w-full max-w-[1600px] flex-col px-4 pb-10 pt-3">
          {/* Breadcrumbs section */}
          {breadcrumbs && (
            <div className="flex h-9 items-center transition-colors duration-200">
              <div className="w-full">{breadcrumbs}</div>
            </div>
          )}
          <div
            className={`flex flex-col gap-4 md:gap-6 ${breadcrumbs ? 'pt-3' : 'pt-6'}`}
          >
            {isLoading ? (
              <Card>
                <CardContent>
                  <ProcessingProgress message="Loading" />
                </CardContent>
              </Card>
            ) : (
              <>{children}</>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
